import { compose, map, filter } from "./functional";

export const collectAttributes = (prefix, elt) =>
  compose(
    Object.fromEntries,
    map(({ name, value }) => [name.substr(prefix.length), value]),
    filter(({ name, value }) => name.startsWith(prefix)),
    x => [...x]
  )(elt.attributes);
